<!-- <app-header-dashboard></app-header-dashboard> -->


<main class="main">
  <div class="invest-container text-white p-3">

    <!-- Header -->
    <div class="d-flex align-items-center mb-3">
      <i class="fas fa-arrow-left me-3"></i>
      <h5 class="mb-0">Invest Now</h5>
    </div>

    <!-- Toggle Buttons -->
    <div class="d-flex mb-3">
      <button class="tab-btn me-2" [class.active]="mode === 'stake'" (click)="mode = 'stake'">
        <i class="fas fa-chart-bar me-1"></i> Stakes
      </button>
      <button class="tab-btn" [class.active]="mode === 'hold'" (click)="mode = 'hold'">
        <i class="fas fa-wallet me-1"></i> Holding
      </button>
    </div>

    <!-- Shared Summary Box -->
    <div class="summary-box p-3 rounded mb-3">
      <h6 class="fw-bold">Summary</h6>
      <p>Available Balance: <span class="text-white">0.000 CRED</span></p>
      <p>Selected Rate:
        <span class="text-success fw-bold">{{ mode === 'stake' ? '0%' : '1%' }}</span>
      </p>
      <p>Duration: <span class="text-white">{{ mode === 'stake' ? '365 Days' : '30 Days' }}</span></p>
    </div>

    <!-- Amount Input -->
    <div class="mb-3">
      <label class="form-label">Amount to {{ mode === 'stake' ? 'Stake' : 'Hold' }}</label>
      <input type="number" class="form-control" placeholder="Enter amount" />
    </div>

    <!-- Duration Dropdown -->
    <div class="mb-3">
      <label class="form-label">Select Duration</label>
      <select class="form-select">
        <option *ngFor="let option of getDurations()">{{ option }}</option>
      </select>
    </div>

    <!-- Info Message -->
    <div class="info-box p-2 rounded mb-3">
      <i class="fas fa-info-circle me-2"></i>
      <span *ngIf="mode === 'stake'">
        Once you stake your coin, you can't withdraw or use it for the selected duration period.
      </span>
      <span *ngIf="mode === 'hold'">
        You can cancel your investment anytime. Earning rate could change during the earn duration.
      </span>
    </div>

    <!-- Action Button -->
    <button class="stake-btn w-100 py-2 rounded fw-bold">
      {{ mode === 'stake' ? 'Stake To Earn' : 'Hold To Earn' }}
    </button>

  </div>

</main>